<h1 class="border-gray border-bottom text-center pb-4 mb-5">Help and Advice</h1>

<div class="text-end mb-4">
    <button class="btn btn-primary btn-round btn-slim" (click)="addTopic()">Add new Topic</button>
</div>

<div class="card border-0 bg-white shadow-sm mb-4">
    <div class="card-body p-xl-5">
        <div class="no-results" *ngIf="!(faq$ | async).data.length">
            <p>No help topics found</p>
        </div>

        <div *ngIf="(faq$ | async).data.length">
            <!--        <input type="text" class="form-control" [(ngModel)]="params.freetext" />-->
            <div
                class="row"
                dragula="priCategory"
                [(dragulaModel)]="faqs"
                (dragulaModelChange)="drop($event)">
                <div
                    class="col-12 col-lg-3 mb-3"
                    *ngFor="let s of faqs">

                    <div class="data-tile">
                        <div class="image-tile" [ngStyle]="{'background-image': 'url(' + s.imageUrl + ')'}"></div>
                        <div class="mt-2">
                            <h1>{{s.name}}</h1>
                        </div>
                        <div class="text-center">
                            <button
                                type="button"
                                class="btn btn-sm"
                                [ngClass]="{'btn-primary' : s.questions.length, 'btn-light' : !s.questions.length}"
                                (click)="viewTopicQuestions(s)">
                                {{s.questions.length}} question<span *ngIf="s.questions.length !== 1">s</span>
                            </button>
                        </div>
                        <div class="row mt-3">
                            <div class="col-3 text-start">
                            <span class="label label-info">
                                <i class="fa fa-bars"></i>
                            </span>
                            </div>
                            <div class="col-3 text-center">
                                <a (click)="toggleStatus(s)">
                                    <i
                                        class="toggle fa"
                                        [ngClass]="{
                            'fa-toggle-on text-success': s.status,
                            'fa-toggle-off' : !s.status}"></i>
                                </a>
                            </div>
                            <div class="col-3 text-center">
                                <a (click)="editTopic(s)">
                                    <img src="assets/images/icon-edit.svg" class="custom-edit-icon">
                                </a>
                            </div>
                            <div class="col-3 text-end">
                                <a (click)="deleteConfirm(s)">
                                    <img src="assets/images/icon-trash.svg" class="custom-delete-icon">
                                </a>
                            </div>
                        </div>

                    </div>

                </div>
            </div>
        </div>
        <app-pagination *ngIf="params.pageArray.length" [params]="params" (update)="search()"></app-pagination>
    </div>
</div>

<app-faq-topic *ngIf="(overlays$ | async).faqTopic" [topic]="topic" (closeAction)="closeAction($event)"></app-faq-topic>
<app-confirmation *ngIf="this.confirmationData.open" (complete)="confirmAction($event)" [data]="confirmationData"></app-confirmation>
